export const isStagingSubdomain = (): boolean => {
  if (typeof window === "undefined") return false;
  if (import.meta.env.MODE === "development") return true;

  const hostname = window.location.hostname.toLowerCase();
  return hostname.startsWith("staging.") || hostname.includes(".staging.");
};
